var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackSLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_543_43367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.1182 14.9648C92.1182 6.74425 85.4433 0.0664062 77.2027 0.0664062H62.9431V29.8526H77.2027C85.4327 29.8526 92.1182 23.1853 92.1182 14.9648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3565 14.9648V0.0664062H32.1814V29.8526H46.441C54.671 29.8526 61.3459 23.1853 61.3459 14.9648H61.3565Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4517 31.5325H32.0862V60.6741H61.4517V31.5325Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.678955 29.208V29.8526H30.5522V0.0664062H29.8541C13.7432 0.0664062 0.678955 13.1157 0.678955 29.208Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.02808 77.1786C1.02808 85.3991 7.70302 92.0769 15.933 92.0769H30.5311V62.2908H15.933C7.70302 62.2908 1.02808 68.958 1.02808 77.1891V77.1786Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1814 77.1786V92.0769H61.3565V62.2908H47.0969C38.8669 62.2908 32.192 68.958 32.192 77.1891L32.1814 77.1786Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9326 92.0664H63.4404C79.5512 92.0664 92.6155 79.0172 92.6155 62.9248V62.2803H62.9326V92.0664Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8858 60.7376H30.5311V31.5959H0.710693C0.710693 47.6883 13.775 60.7376 29.8858 60.7376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5144 31.5959H62.8691V60.7376H92.6895C92.6895 44.6452 79.6253 31.5959 63.5144 31.5959Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_543_43367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    fill: "white",
    transform: "translate(0.678955 0.0664062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackSLogo);
export default __webpack_public_path__ + "static/media/BlackSLogo.34f0c64da569da4555b1aef0825bd9b5.svg";
export { ForwardRef as ReactComponent };